import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { change, getFormValues, isDirty } from 'redux-form'
import { get, isFinite } from 'lodash'

import EventSuiteDetails from '../../components/Suite/Details'
import Money from '../../utils/money'

import {
  createNoOptimisticCustomerOrderingPreferences,
  loadAllCustomerOrderingPreferencesByEventIdByCustomerId,
} from '../../store/CustomerOrderingPreference/actions'
import { loadCustomerPayments, setCustomerPaymentAuthorizedSignatory } from '../../store/CustomerPayment/actions'
import { loadSalesEvents } from '../../store/Event/actions'
import { loadPreOrders } from '../../store/Order/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { loadCustomers } from '../../store/Customer/actions'
import { getCurrentVenueUuid } from '../../store/Venues/selector'

import SuiteOrderingPreferenceViewModel from '../../viewmodels/SuiteOrderingPreferenceViewModel'

import makeCustomerPreferences from '../../utils/customerPreferences'
import makePreferredPaymentList from '../../utils/customerPayments'

import { getFormRegisteredFields, makeGetDisplaySuite } from '../../store/Suite/selector'
import { makeGetCustomerPayments, getIsPaymentLoading } from '../../store/CustomerPayment/selector'
import { makeGetAllCustomerStandPreferences, getIsOrderingPreferencesLoading } from '../../store/CustomerOrderingPreference/selector'
import { makeGetSalesEvent, getIsSalesEventLoading } from '../../store/Event/selector'
import { getIsCustomerLoading } from '../../store/Customer/selector'
import { getIsPreOrdersLoading } from '../../store/Order/selector'
import { getIsRevenueCentersLoading } from '../../store/RevenueCenter/selector'

const mapStateToProps = (state, ownProps) => {
  const eventId = get(ownProps, 'match.params.eventId')
  const standId = get(ownProps, 'match.params.standId')
  const customerId = get(ownProps, 'match.params.customerId')
  const getDisplaySuite = makeGetDisplaySuite()
  const getCustomerPayments = makeGetCustomerPayments()
  const getSalesEvent = makeGetSalesEvent()
  const getAllCustomerStandPreferences = makeGetAllCustomerStandPreferences()

  const salesEvent = getSalesEvent(state, eventId)
  const displaySuite = getDisplaySuite(state, eventId, standId, customerId)
  const customerPayments = getCustomerPayments(state, customerId)
  const customerOrderingPreferences = getAllCustomerStandPreferences(state, customerId, standId)
  const formattedPreference = makeCustomerPreferences(customerOrderingPreferences, customerPayments, eventId, standId)
  const customerOrderingPreference = SuiteOrderingPreferenceViewModel(formattedPreference)
  const preferredPaymentList = makePreferredPaymentList(customerOrderingPreferences, customerPayments, standId)
  const initialValues = formattedPreference
  const menuTypes = ['preorder', 'day_of_event', 'coffee', 'dessert', 'cordial', 'restock']
  menuTypes.forEach(menuType => {
    const isPercent = initialValues[menuType].gratuityIsPercentage
    const gratuity = initialValues[menuType].gratuity
    const maxGratuity = initialValues[menuType].maxGratuity

    initialValues[menuType].gratuity = Money.displayGratuityInDollarOrPercentage(gratuity, isPercent)
    initialValues[menuType].maxGratuity = isFinite(maxGratuity) ? Money.displayGratuityInDollarOrPercentage(maxGratuity) : undefined
  })

  initialValues['fridgeUnlocked'] = !initialValues['lockRefrigerator']
  initialValues['liquorCabinetUnlocked'] = !initialValues['lockLiquorCabinet']

  const formFields = getFormRegisteredFields(state)
  const formAltered = (field) => isDirty('ordering-preference')(state, [field])
  const formValues = getFormValues('ordering-preference')(state)
  const currentVenueUuid = getCurrentVenueUuid(state)

  const isCustomerLoading = getIsCustomerLoading(state)
  const isOrderingPreferencesLoading = getIsOrderingPreferencesLoading(state)
  const isPreOrdersLoading = getIsPreOrdersLoading(state)
  const isPaymentLoading = getIsPaymentLoading(state)
  const isRevenueCentersLoading = getIsRevenueCentersLoading(state)
  const isSalesEventLoading = getIsSalesEventLoading(state)

  return {
    currentVenueUuid,
    customerId,
    customerPayments,
    event: salesEvent,
    eventId,
    formAltered,
    formFields,
    formValues,
    history: ownProps.history,
    initialValues,
    isCustomerLoading,
    isOrderingPreferencesLoading,
    isPaymentLoading,
    isPreOrdersLoading,
    isRevenueCentersLoading,
    isSalesEventLoading,
    orderingPreference: customerOrderingPreference,
    preferredPaymentList,
    standId,
    suite: displaySuite,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const salesEventId = get(ownProps, 'match.params.eventId', '')

  return {
    createNoOptimisticCustomerOrderingPreferences: (customerId, params) => dispatch(createNoOptimisticCustomerOrderingPreferences(customerId, params)),
    onMount: (customerId, currentVenueUuid) => {
      dispatch(loadAllCustomerOrderingPreferencesByEventIdByCustomerId(salesEventId, customerId))
      dispatch(loadCustomerPayments(customerId))
      dispatch(loadCustomers(currentVenueUuid))
      dispatch(loadPreOrders(currentVenueUuid, salesEventId))
      dispatch(loadRevenueCenters(currentVenueUuid))
      dispatch(loadSalesEvents(currentVenueUuid))
    },
    loadCustomerPayments: customerId => dispatch(loadCustomerPayments(customerId)),
    loadAllCustomerOrderingPreferencesByEventIdByCustomerId: (salesEventId, customerId) => dispatch(loadAllCustomerOrderingPreferencesByEventIdByCustomerId(salesEventId, customerId)),
    onFieldValueChange: (field, value) => dispatch(change('ordering-preference', field, value)),
    setCustomerPaymentAuthorizedSignatory: customerPayment => dispatch(setCustomerPaymentAuthorizedSignatory(customerPayment))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventSuiteDetails))
